import { put, select } from 'redux-saga/effects';
import { getFormValue } from '../state_selectors';

/**
 * DriverOption question gets skipped if driver is younger than 21, so we need to set the value to no restricitons
 */
const preSetRestrictionsSaga = function* () {
    const driverOptionIdentifier = 'coverDetail.driverOption';
    const driverOption = yield select(getFormValue, driverOptionIdentifier);
    if (!driverOption) {
        yield put({
            type: 'SET_VALUE',
            value: 'NO_RESTRICTION',
            stateKey: 'vertical.quote',
            identifier: 'coverDetail.driverOption'
        });
    }
};

export default ['PRE_SET_RESTRICTIONS', preSetRestrictionsSaga];
